import type React from "react";

import { colorsSelector } from "@redux/colorPalette/selectors";
import { useLastSongSelector } from "@redux/player";
import { useDroppable } from "@dnd-kit/core";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import { DROPPABLETYPES } from "types/droppables";
import {
	LastSongContainer,
} from "./LastSong.style";
import LastSongItemWrapper from "./components/LastSongItemWrapper";
import { StyledListItem } from "../SongList/SongList.style";
import { Typography } from "@mui/material";

export const LastSong: React.FC = () => {
	const lastSong = useLastSongSelector();
	const colors = useSelector(colorsSelector);

	const { setNodeRef } = useDroppable({
		id: DROPPABLETYPES.LAST_SONG,
	});

	return (
		<StyledListItem colors={colors} highlighted>
			<LastSongContainer
				$on={!lastSong.disableFeatures}
				{...{ colors }}
				ref={setNodeRef}
			>
				{lastSong.song ? <LastSongItemWrapper /> : <Typography textAlign={"center"} width="100%" fontSize={14}>
					<FormattedMessage
						id="song.drop-last-here"
						defaultMessage="No last song" />
				</Typography>}

			</LastSongContainer>
		</StyledListItem>
	);
};
